<div mat-dialog-content>
    <div class="mat-dialog-content">
        <div class="img-head">
            <img class="img-class" src="assets/images/confirm-circle.png" />
        </div>
        <div class="title-header">
            <h2>Paciente encontrado!</h2>
        </div>

        <div *ngIf="patient">
            <div class="section-container">
                <div class="row section-personal-data">
                    <div *ngIf="patient.socialName">
                        <span><b>Nome: </b></span>
                        <span>{{ patient.socialName }}</span>
                    </div>
                    <div *ngIf="patient.patientName">
                        <span><b>Nome: </b></span>
                        <span>{{ patient.patientName }}</span>
                    </div>
                    <div *ngIf="patient.patientSocialName">
                        <span><b>Nome social: </b></span>
                        <span>{{ patient.patientSocialName }}</span>
                    </div>
                    <div *ngIf="patient.birthDate">
                        <span><b>Data de Nascimento: </b></span>
                        <span>{{ patient.birthDate | date: 'dd/MM/yyyy' }}</span>
                    </div>
                    <div *ngIf="patient.motherName">
                        <span><b>Nome da Mãe: </b></span>
                        <span>{{ patient.motherName }}</span>
                    </div>
                    <div *ngIf="phoneMask">
                        <span><b>Telefone: </b></span>
                        <span>{{ phoneMask }}</span>
                    </div>
                    <div *ngIf="formattedAddress" class="address">
                        <span><b>Endereço: </b></span>
                        <div>
                            <span>{{ formattedAddress }}</span>
                        </div>
                    </div>
                </div>

                <div class="section-photo" *ngIf="patient.profilePicture">
                    <img class="patient-photo" [src]="'data:image/jpeg;base64,' + patient.profilePicture"
                        alt="Foto do paciente" />
                </div>
            </div>
        </div>
    </div>
</div>

<div class="footer-confirm-modal-list">
    <button mat-flat-button color="accent" class="btn-block" (click)="close()">
        Não sou eu
    </button>
    <button mat-flat-button color="accent" class="btn-block button-data-wrong" (click)="outdatedAddress()">
        Dados incorretos
    </button>
    <button mat-flat-button color="primary" class="btn-block" (click)="confirmPatient()">
        Continuar
    </button>
</div>